import React, { useState } from 'react'
import { Button, Col, Form, Icon, Input, Radio, Row, Upload } from 'antd'
import { ButtonEx } from '../../../styles/button.style'
import { useDeepEffect } from '../../../utils/hooks'
import _, { isNull } from 'lodash'
import { beforeUpload, compressFile, getBase64 } from '../../../utils/services'
import axios from 'axios'

const BrandProfile = ({ form, onOk, onCancel, formData }) => {
  const { setFieldsValue, getFieldDecorator, validateFields } = form
  const [imageUrl, setImageUrl] = useState('')
  const [characterCount, setcharacterCount] = useState(0)

  useDeepEffect(() => {
    if (!_.isEmpty(formData)) {
      setFieldsValue({
        caption: formData.caption,
        link: formData.link,
        name: formData.name,
        sponsorTag: formData.sponsorTag
      })
      setImageUrl(formData.logo)
      setcharacterCount(formData.caption.length)
    }

    return () => {
      form.resetFields()
      setImageUrl('')
    }
  }, [formData])

  async function uploadBrandImage(file) {
    try {
      const formData = new FormData()
      formData.append('image', await compressFile(file))
      const token = localStorage.getItem('user-token')
      const res = await axios.post(
        `${process.env.REACT_APP_API_ENDPOINT}/brand/image`,
        formData,
        {
          headers: {
            'content-type': 'multipart/form-data',
            Authorization: !_.isNull(token) ? token : ''
          }
        }
      )

      return res.data
    } catch (err) {
      return null
    }
  }

  async function handleChange(info) {
    await getBase64(info.file, (imageUrl) => {
      setImageUrl(imageUrl)
    })
  }

  const uploadButton = (
    <div>
      <Icon type="plus" />
      <div className="ant-upload-text">Upload</div>
    </div>
  )

  function onSubmit(e) {
    e.preventDefault()
    validateFields(async (err, values) => {
      if (!err) {
        const data = {
          caption: values.caption,
          link: values.link,
          name: values.name,
          sponsorTag: values.sponsorTag
        }

        if (values.image) {
          const img = await uploadBrandImage(values.image.file)
          data.image = img.url
        } else {
          data.image = formData.logo
        }

        if (!_.isEmpty(formData)) {
          data.id = formData.id
        }
        onOk(data)
        setImageUrl('')
      }
    })
  }

  return (
    <Form onSubmit={onSubmit} layout="vertical">
      <Form.Item label="Brand Image">
        {getFieldDecorator(`image`, {
          rules: [
            {
              required: isNull(formData),
              message: 'เลือกรูปภาพ'
            }
          ]
        })(
          <Upload
            name="avatar"
            listType="picture-card"
            showUploadList={false}
            beforeUpload={(file) => beforeUpload(file)}
            onChange={handleChange}>
            {imageUrl ? (
              <img src={imageUrl} alt="avatar" style={{ width: '100%' }} />
            ) : (
              uploadButton
            )}
          </Upload>
        )}
      </Form.Item>
      <Form.Item label="Brand Name">
        {getFieldDecorator(`name`, {
          rules: [
            {
              required: true,
              message: 'กรุณากรอก'
            }
          ]
        })(<Input />)}
      </Form.Item>
      <Form.Item label="Brand Description">
        {getFieldDecorator(`caption`, {
          rules: [
            {
              required: true,
              message: 'กรุณากรอก'
            }
          ]
        })(<Input.TextArea autoSize={{ minRows: 4 }} maxLength={1000} onChange={(e) => setcharacterCount(e.target.value.length)} />)}
        <div style={{
          display: 'flex',
          alignItems: 'flex-end',
          flexDirection: 'column'
        }}>{characterCount}/1000</div>
      </Form.Item>
      <Form.Item label="Brand Website">
        {getFieldDecorator(`link`, {
          rules: [
            {
              required: true,
              message: 'กรุณากรอก'
            }
          ]
        })(<Input />)}
      </Form.Item>
      <Form.Item label="Sponsor">
        {getFieldDecorator(`sponsorTag`, {
          rules: [
            {
              required: true,
              message: 'กรุณาเลือก'
            }
          ]
        })(
          <Radio.Group>
            <Radio value={true}>Yes</Radio>
            <Radio value={false}>No</Radio>
          </Radio.Group>
        )}
      </Form.Item>
      <Row type="flex" gutter={8} justify="end">
        <Col>
          <Button onClick={() => onCancel()}>ยกเลิก</Button>
        </Col>
        <Col>
          <ButtonEx color="#6ebf4b" type="primary" htmlType="submit">
            บันทึก
          </ButtonEx>
        </Col>
      </Row>
    </Form>
  )
}

const WrappedBrandProfile = Form.create({ name: 'BrandProfile' })(BrandProfile)
export default WrappedBrandProfile



// WEBPACK FOOTER //
// ./src/pages/Brand/BrandProfile/index.js